// extracted by mini-css-extract-plugin
module.exports = {"loader":"handle-auth_loader__6QfIp"};